import Vue from 'vue'
import App from './App'
import router from './router'


import * as http from './assets/js/http'
import * as publicJs from './assets/js/public'
import * as cookie from './utils/cookie'
import echarts from 'echarts'
// import BaiduMap from 'vue-baidu-map';
import 'element-ui/lib/theme-chalk/index.css'
// import './assets/css/public.styl'
import './assets/css/style.less'
import './assets/font/iconfont.css'
import store from './store/index'

import ElementUI from 'element-ui'
// 适配flex
import './utils/flexible.js';
// Vue.use(BaiduMap, {
//   ak: 'NsETn6A8OjeSKAQzG3dxNx1E'		//使用申请的百度地图秘钥
// })
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$cookieStore = cookie
Vue.prototype.$http = http
Vue.prototype.$echarts = echarts
Vue.prototype.$public = publicJs
/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// 初始化
// console.log(this)
// publicJs.textSetting(400,1920);
// // publicJs.setRem()
// // 改变窗口大小时重新设置 rem
// window.onresize = function () {
//   publicJs.textSetting(400,1920);
// }

http.setVue(vue)




// WEBPACK FOOTER //
// ./src/main.js